import { memo } from 'react';
import { UnlimitedDemoTradesStatusStyled } from './styled/UnlimitedDemoTradesStatusStyled';
import { useLangContext } from '../../../providers/LangProvider/LangProviderContext';
import BinIcon from '../../../components/icon/IconWrapped';

function UnlimitedDemoTradesStatus() {
    const { getLangPath } = useLangContext();

    return <UnlimitedDemoTradesStatusStyled>
        <div className={'unlimited-demo-trade-status-circle'}>
            <BinIcon name={'IcInfinity'} size={26}/>
        </div>
        <span>{getLangPath('demo_limits.unlimited_demo_trades')}</span>
    </UnlimitedDemoTradesStatusStyled>;
}

export default memo(UnlimitedDemoTradesStatus);
